<template >
    <div class="login__container">
        <img :src="images.logo" alt="Логотип" class="login__logo">
        <h2 class="login__title">Вход в приложение</h2>
        <form @submit.prevent="submit" action="" method="post" class="login__form">
            <input-component v-model:meaning="values.identity" @input="errors.identity= ''" inputType="text" inputName="login" inputContent="admin" inputLabel="Логин" :inputError="errors.identity" required />
            <input-component v-model:meaning="values.password" @input="errors.password= ''"  inputType="password" inputName="password" inputAutocomplete="on" inputContent="********" inputLabel="Пароль" :inputError="errors.password" :clear="true" :showPass="true" required />
            <select v-model="values.regionId" name="regionId" required @change="getCityIndex($event)">
                <option value="" disabled selected>Выберите город</option>
                <option v-for="city in citiesList" :value="city._id" :key="city._id" :data-city-index="city.index">{{ city.name }}</option>
            </select>
            <input type="hidden" name="currentRegionIndex" value="">
            <label class="login__save-box">
                <input v-model="checked" type="checkbox" class="login__save">
                <span class="login__save-text">Запомнить меня</span>
            </label>
            <div class="login__button-box">
                <button-component buttonText="Войти" class="login__button" />
                <router-link :to="{name:'restore'}" class="login__link">Забыли пароль?</router-link>
            </div>
        </form>
        <router-link v-if="onlineStore.isOnline === false" :to="{name:'createOrder'}" class="login__link">создать заказ</router-link>
    </div>
</template>
<script setup lang="ts">
import logo from '../assets/img/svg/logo.svg'
import InputComponent from '../shared/Form/Input/InputComponent.vue'
import buttonComponent from '../shared/buttonComponent.vue'
import * as yup from 'yup'
import toast from '../app/lib/hooks/errorToast'
import axios from '../app/lib/api'
import { onMounted, ref } from 'vue'
import router from '../app/router/router'
import { useLoadingStore, useOnlineStore } from '../app/store/store'
import { Cities } from '../app/lib/types/cities'

const citiesList = ref([] as unknown as Cities[])
const loading = useLoadingStore()
const onlineStore = useOnlineStore()

const images = {
    logo: logo
}

const values = ref({
  identity: '',
  password: '',
  regionId: '',
  currentRegionIndex: ''
})

const errors = ref({
  identity: '',
  password: '',
  regionId: ''
})

const loginShema = yup.object({
  identity: yup.string().required('Введите логин'),
  password: yup.string().required('Введите пароль'),
  regionId: yup.string().required('Выберите город'),
})

let checked = ref(false)

const login = async () => {
    try {
        const res = await axios.auth.login(values.value)
        if (checked.value == true) {
            document.cookie = `access_token=${res.data.accessToken}; path=/`
        } else {
            document.cookie = `access_token=${res.data.accessToken}; path=/`
        }
        localStorage.setItem("role", res.data.role)
        localStorage.setItem("regionId", res.data.region)
        router.push({name: 'main'})
        toast('success', "Вы успешно авторизовались")
    }
    catch (err: any) {
        toast('error', err.response.data.message)
    }
}

onMounted(() => {
    axios.cities.getCitiesList()
    .then((r: any) => {
        citiesList.value = r.data
    })
    .catch((err: any) => {
        loading.load()
        toast('error', err + ' Не удалось получить список городов')
    })
})

/**
 * Получение индекса города, для дальнейшей работы с ним после аутентификации.
 */
function getCityIndex(e: any) {
    values.value.currentRegionIndex = e.target.options[e.target.options.selectedIndex].getAttribute('data-city-index')
}

/**
 * Отправка формы.
 * 
 * @param e
 */
async function submit(e: any) {
    try {
        await loginShema.validate(values.value, { abortEarly: false })
        errors.value = {
            identity: '',
            password: '',
            regionId: ''
        }
        return await login()
    }
    catch(err: any) {
        // @ts-ignore
        err.inner.forEach((error) => {
        // @ts-ignore
        errors.value[error.path] = error.message
        })
    }
}
</script>